'use strict';
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable from "./com.raquo.airstream.core.-Base-Observable.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dObserver$0024 from "./com.raquo.airstream.core.-Observer$.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dSignal from "./com.raquo.airstream.core.-Writable-Signal.js";
import * as $j_com$002eraquo$002eairstream$002emisc$002e$002dMap$002dSignal from "./com.raquo.airstream.misc.-Map-Signal.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_airstream_state_DerivedVarSignal(parent, zoomIn, owner, parentDisplayName) {
  this.uR = null;
  this.uQ = false;
  this.uS = null;
  this.rC = 0;
  this.uO = null;
  this.uP = null;
  this.uV = false;
  this.rE = null;
  this.uT = false;
  this.rD = 0;
  this.rF = null;
  this.rG = null;
  this.rH = null;
  this.uU = 0;
  this.F0 = null;
  this.F0 = parentDisplayName;
  $j_com$002eraquo$002eairstream$002emisc$002e$002dMap$002dSignal.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(this, parent.a4(), zoomIn, $j_java$002elang$002e$002dObject.$m_s_None$());
  $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_WritableObservable__addObserver__Lcom_raquo_airstream_core_Observer__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(this, $j_com$002eraquo$002eairstream$002ecore$002e$002dObserver$0024.$m_Lcom_raquo_airstream_core_Observer$().DC, owner);
}
export { $c_Lcom_raquo_airstream_state_DerivedVarSignal as $c_Lcom_raquo_airstream_state_DerivedVarSignal };
$p = $c_Lcom_raquo_airstream_state_DerivedVarSignal.prototype = new $j_com$002eraquo$002eairstream$002emisc$002e$002dMap$002dSignal.$h_Lcom_raquo_airstream_misc_MapSignal();
$p.constructor = $c_Lcom_raquo_airstream_state_DerivedVarSignal;
/** @constructor */
function $h_Lcom_raquo_airstream_state_DerivedVarSignal() {
}
export { $h_Lcom_raquo_airstream_state_DerivedVarSignal as $h_Lcom_raquo_airstream_state_DerivedVarSignal };
$h_Lcom_raquo_airstream_state_DerivedVarSignal.prototype = $p;
$p.b3 = (function() {
  return $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dSignal.$f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this);
});
$p.dd = (function() {
  return (this.F0.h() + ".signal");
});
var $d_Lcom_raquo_airstream_state_DerivedVarSignal = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_state_DerivedVarSignal, "com.raquo.airstream.state.DerivedVarSignal", ({
  hg: 1,
  c2: 1,
  a1: 1,
  M: 1,
  ai: 1,
  ak: 1,
  au: 1,
  az: 1,
  as: 1,
  aQ: 1,
  aj: 1,
  ay: 1,
  b1: 1,
  c3: 1,
  hj: 1
}));
export { $d_Lcom_raquo_airstream_state_DerivedVarSignal as $d_Lcom_raquo_airstream_state_DerivedVarSignal };
